import { createAction } from 'redux-starter-kit';

export const SET_DRAGGED_ITEM = 'set-dragged-item';

const setDraggedItem = createAction(SET_DRAGGED_ITEM);

export const dragAndDropActions = {
  setDraggedItem
};
